import Calendar from '@fullcalendar/react'; // => request placed at the top
// @fullcalendar
import plLocale from '@fullcalendar/core/locales/pl';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import timelinePlugin from '@fullcalendar/timeline';
//
import { useEffect } from 'react';
// @mui
// utils
// hooks
import { useBoolean } from '../hooks/use-boolean';
// _mock
// api
// components
// types
//
import { EventClickArg } from '@fullcalendar/core';
import CalendarEvent from '../calendar-event';
import CalendarProfessionalDetailsToolbar from '../calendar-professional-details-toolbar';
import { useCalendar } from '../hooks';
import { StyledCalendar } from '../styles';
import { ICalendarEvent } from '../types/calendar';

// ----------------------------------------------------------------------

export type CalendarProfessionalDetailsViewProps = {
  events: ICalendarEvent[];
  onEventClick?: (arg: EventClickArg) => void;
  onTimeOff?: VoidFunction;
};

export default function CalendarProfessionalDetailsView({
  events,
  onEventClick,
  onTimeOff,
}: CalendarProfessionalDetailsViewProps) {
  const openFilters = useBoolean();

  const {
    calendarRef,
    view,
    date,
    onDatePrev,
    onDateNext,
    onDateToday,
    onChangeView,
    onInitialView,
    onChangeDate,
  } = useCalendar();

  // const currentEvent = useEvent(events, selectEventId, selectedRange, openForm);

  useEffect(() => {
    onInitialView();
  }, [onInitialView]);

  return (
    <>
      <StyledCalendar>
        <CalendarProfessionalDetailsToolbar
          date={date}
          view={view}
          loading={false}
          onNextDate={onDateNext}
          onPrevDate={onDatePrev}
          onToday={onDateToday}
          onChangeView={onChangeView}
          onOpenFilters={openFilters.onTrue}
          onChangeDate={onChangeDate}
          onTimeOff={onTimeOff}
        />

        <Calendar
          locale={plLocale}
          firstDay={1}
          weekends
          allDaySlot={false}
          rerenderDelay={10}
          allDayMaintainDuration
          eventResizableFromStart
          ref={calendarRef}
          initialDate={date}
          initialView={view}
          dayMaxEventRows={3}
          eventDisplay="block"
          events={events}
          headerToolbar={false}
          eventClick={onEventClick}
          height={'100%'}
          nowIndicator
          longPressDelay={250}
          eventLongPressDelay={250}
          selectLongPressDelay={250}
          slotLabelFormat={{
            hour: 'numeric',
            minute: '2-digit',
          }}
          slotDuration="00:10:00"
          plugins={[
            listPlugin,
            dayGridPlugin,
            timelinePlugin,
            timeGridPlugin,
            interactionPlugin,
          ]}
          scrollTime={new Date().getHours().toString() + ':00'}
          eventContent={(eventContent) => (
            <CalendarEvent event={eventContent} />
          )}
        />
      </StyledCalendar>
    </>
  );
}
